import { render, staticRenderFns } from "./PageDetailsContainer.vue?vue&type=template&id=a5b41cc8"
import script from "./PageDetailsContainer.vue?vue&type=script&lang=js"
export * from "./PageDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports